
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function KIacarenceonrentinpune() {



    const cardData =
    {
        keyword: 'Kia Carens on Rent in Pune',
        heading: 'Morya Cabs: Kia Carens on Rent in Pune',
        headingDescription: 'Morya Cabs offers the stylish and spacious Kia Carens on rent in Pune, perfect for families, groups, or anyone looking for a comfortable and premium ride. With its luxurious features, ample space, and smooth driving experience, the Kia Carens is an excellent choice for both short and long-distance trips. Whether you need it for a family vacation, business trip, or special event, our rental service ensures that you travel in comfort and style',

        top: 'Top Destinations for Kia Carens Rental in Pune:',

"topPlaces": [
    {
        "title": "Shirdi",
        "description": "A sacred pilgrimage destination, Shirdi attracts thousands of devotees seeking blessings at the renowned Sai Baba Temple. Located just a few hours from Pune, it is a peaceful retreat for spiritual seekers. Renting a Kia Carens ensures a smooth and comfortable journey for families and groups, offering ample space for passengers and luggage while making the long drive relaxing and enjoyable."
    },
    {
        "title": "Lavasa",
        "description": "Lavasa, a picturesque hill station near Pune, is known for its serene lakeside views, European-inspired architecture, and adventure activities. Whether you're planning a family trip or a weekend getaway with friends, the Kia Carens provides a comfortable ride with spacious interiors, making the scenic drive even more enjoyable."
    },
    {
        "title": "Mahabaleshwar",
        "description": "Mahabaleshwar is famous for its cool weather, lush greenery, and stunning viewpoints like Arthur’s Seat and Wilson Point. Whether you want to explore strawberry farms, waterfalls, or ancient temples, the Kia Carens offers a luxurious and spacious ride, ensuring that your group travels comfortably throughout this long yet scenic journey."
    },
    {
        "title": "Matheran",
        "description": "Matheran is India's only eco-sensitive hill station, known for its pollution-free environment, horse rides, and toy train. It's an excellent choice for those looking to escape the city and enjoy nature. With the Kia Carens, your group can travel comfortably to the base of Matheran, from where you can explore the tranquil surroundings at your own pace."
    },
    {
        "title": "Lonavala & Khandala",
        "description": "Lonavala and Khandala are among the most popular weekend getaways from Pune, famous for their lush green valleys, waterfalls, and caves. Whether you're visiting Tiger's Leap, Bhushi Dam, or Karla Caves, the Kia Carens provides a smooth and spacious ride, making your trip to these scenic hill stations even more enjoyable."
    },
    {
        "title": "Alibaug",
        "description": "Alibaug is a coastal paradise offering pristine beaches, historical forts, and water sports. Whether you plan to relax by the beach or explore the famous Kolaba Fort, the Kia Carens rental provides ample space for your group and luggage, ensuring a comfortable journey to this beautiful seaside town."
    },
    {
        "title": "Sinhagad Fort",
        "description": "A historical gem near Pune, Sinhagad Fort is a popular destination for trekkers and history lovers. The fort offers stunning panoramic views and a glimpse into Maratha history. Renting a Kia Carens allows your group to travel in comfort and style, making the drive to this iconic fort a hassle-free experience."
    },
    {
        "title": "Panchgani",
        "description": "Panchgani is a charming hill station known for its breathtaking views, strawberry farms, and pleasant climate. Whether you want to visit Table Land or enjoy a peaceful retreat in nature, the Kia Carens ensures that your journey is as comfortable as your stay at this tranquil destination."
    },
    {
        "title": "Tungabhadra Dam",
        "description": "For those seeking a peaceful getaway, Tungabhadra Dam offers a serene environment surrounded by natural beauty. The scenic location is perfect for a relaxing day trip, and renting a Kia Carens ensures a smooth and enjoyable ride for your group, allowing you to travel in comfort while taking in the breathtaking views."
    },
    {
        "title": "Bhandardara",
        "description": "Bhandardara is a hidden gem known for its beautiful lakes, lush landscapes, and mesmerizing waterfalls like Randha Falls. Whether you're planning a nature retreat, camping trip, or sightseeing tour, the Kia Carens provides a spacious and comfortable ride, making your journey to this picturesque destination a memorable one."
    }
],


"services": [
    {
      "name": "Kia Carens on Rent in Pune Near Me",
      "description": "Morya Cab offers Kia Carens on rent in Pune for both local and outstation travel. Enjoy the comfort and spaciousness of the Kia Carens for your family trips or corporate outings."
    },
    {
      "name": "Kia Carens on Rent in Pune Near Me Contact Number",
      "description": "For booking a Kia Carens on rent in Pune, you can contact Morya Cab at +91 9371304510. We are here to assist you with your rental needs for a comfortable and smooth journey."
    },
    {
      "name": "Kia Carens for Rent in Pune",
      "description": "Morya Cab provides Kia Carens for rent in Pune for both short trips and long-distance travel. Our vehicles are well-maintained, ensuring a pleasant and safe ride."
    },
    {
      "name": "Pune to Shirdi Kia Carens on Rent",
      "description": "Rent a Kia Carens for your trip from Pune to Shirdi with Morya Cab. Enjoy the spacious interiors and comfort of the Kia Carens while traveling to Shirdi with your family or group."
    },
    {
      "name": "Kia Carens for Rent for Corporate",
      "description": "Morya Cab offers Kia Carens for corporate use in Pune. Perfect for team outings, business trips, or conferences, our Kia Carens provide the comfort and professionalism you need."
    },
    {
      "name": "Kia Carens Hire for Outstation",
      "description": "Planning an outstation trip? Morya Cab offers Kia Carens for hire, providing ample space and comfort for long-distance travel. Whether it's a weekend getaway or a corporate trip, we’ve got you covered."
    },
    {
      "name": "Pune to Nashik Kia Carens on Rent",
      "description": "Rent a Kia Carens for your journey from Pune to Nashik. Morya Cab offers a reliable and comfortable ride to Nashik, making your trip relaxing and enjoyable."
    },
    {
      "name": "Pune to Goa Kia Carens on Rent",
      "description": "For a trip from Pune to Goa, rent a Kia Carens with Morya Cab. Our spacious and comfortable car ensures that you travel in style and comfort for your Goa getaway."
    },
    {
      "name": "Pune to Mumbai Kia Carens on Rent",
      "description": "Morya Cab offers Kia Carens on rent for your Pune to Mumbai journey. Enjoy a stress-free and comfortable ride with our professional drivers and well-maintained vehicles."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Kia Carens on Rent",
      "description": "For your Ashtavinayak Darshan trip, rent a Kia Carens from Morya Cab. Our vehicles are spacious, ensuring comfort and a relaxing experience on this sacred journey."
    },
    {
      "name": "Pune to Jyotirlinga Darshan Kia Carens on Rent",
      "description": "Morya Cab provides Kia Carens on rent for your Jyotirlinga Darshan trip. Travel comfortably and conveniently while visiting the famous temples with family or friends."
    },
    {
      "name": "Kia Carens Cabs on Rent in Pune",
      "description": "Looking for a Kia Carens cab in Pune? Morya Cab offers Kia Carens on rent for various trips, ensuring a comfortable and premium ride for all your travel needs."
    },
    {
      "name": "Luxury Cars Kia Carens Rental Services",
      "description": "Morya Cab offers luxury car rental services, including the Kia Carens. Ideal for those seeking a more comfortable and stylish ride, our rental options cater to your needs for local or outstation travel."
    },
    {
      "name": "Luxury Car Monthly Rental",
      "description": "If you require a luxury car for an extended period, Morya Cab offers monthly rentals of luxury cars, including the Kia Carens, for both business and personal use."
    },
    {
      "name": "Kia Carens on Rent in Pune",
      "description": "Morya Cab offers Kia Carens on rent in Pune for local and outstation travel. Whether you're planning a family trip or a corporate event, our Kia Carens ensure comfort and style."
    },
    {
      "name": "Kia Carens on Rent for Outstation",
      "description": "Travel outstation in style with Morya Cab's Kia Carens. Offering ample space and comfort, our vehicles are perfect for long-distance trips to various destinations."
    },
    {
      "name": "7-Seater Car on Rent in Pune",
      "description": "Morya Cab provides 7-seater cars on rent in Pune, including the Kia Carens, perfect for family and group outings. Book your ride for a comfortable journey."
    },
    {
      "name": "7-Seater Kia Carens on Rent in Pimpri Chinchwad",
      "description": "Morya Cab offers 7-seater Kia Carens on rent in Pimpri Chinchwad for a convenient and comfortable travel experience. Whether it's for a local trip or outstation journey, we provide reliable service."
    },
    {
      "name": "Kia Carens on Rent in Pimpri Chinchwad",
      "description": "For residents of Pimpri Chinchwad, Morya Cab offers Kia Carens on rent, ensuring a smooth and enjoyable ride for both local and outstation trips. Contact us for your next trip."
    }
  ],


  tableData: [
    ["Kia Carens on Rent in Pune Near Me", "-Kia Carens on Rent in Pune Near Me Contact Number"],
    ["Kia Carens for Rent in Pune", "-Pune to Shirdi Kia Carens on Rent"],
    ["Kia Carens for Rent for Corporate", "-Kia Carens Hire for Outstation"],
    ["Pune to Nashik Kia Carens on Rent", "-Pune to Goa Kia Carens on Rent"],
    ["Pune to Mumbai Kia Carens on Rent", "-Pune to Ashtavinayak Darshan Kia Carens on Rent"],
    ["Pune to Jyotirlinga Darshan Kia Carens on Rent", "-Kia Carens Cabs on Rent in Pune"],
    ["Luxury Cars Kia Carens Rental Services", "-Luxury Car Monthly Rental"],
    ["Kia Carens on Rent in Pune", "-Kia Carens on Rent for Outstation"],
    ["7 Seater Car on Rent in Pune", "-7 Seater Kia Carens on Rent in Pimpri Chinchwad"],
    ["Kia Carens on Rent in Pimpri Chinchwad", ""]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Morya Cab, we prioritize punctuality for your comfort and convenience. Whether you’re heading for a family trip, a corporate event, or a leisure getaway, our Kia Carens is always ready for a timely pickup and smooth ride."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "The Kia Carens is a perfect choice for group travel. With seating for up to 7 passengers, this spacious and comfortable vehicle comes with ample legroom and air-conditioning, ensuring a relaxed and enjoyable journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are skilled and experienced in long-distance travel, ensuring a safe and smooth journey. They are courteous and professional, always prioritizing your comfort and safety during your ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive and transparent pricing for Kia Carens rentals. We believe in clear, upfront pricing with no hidden charges, ensuring that you get the best value for your money."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our top priority. The Kia Carens comes equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring you a secure and comfortable journey at all times."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Morya Cab is available 24/7, so whether you’re traveling early in the morning or late at night, we’re always ready to cater to your needs. Our customer service team is available to assist you at any time."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a Kia Carens on rent with Morya Cab is easy and hassle-free. You can book online through our website or app, or contact our customer service team for personalized assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether it’s a family vacation, business trip, or a sightseeing tour, we offer customized travel packages with the Kia Carens to suit your specific needs and preferences, ensuring you have a memorable experience."
    }
]








    }

    const faqData = [
        {
          question: "How can I book a Kia Carens on rent with Morya Cab?",
          answer: "You can easily book a Kia Carens through our website or mobile app. Alternatively, you can contact our customer service team for further assistance."
        },
        {
          question: "How many passengers can the Kia Carens accommodate?",
          answer: "The Kia Carens comfortably accommodates up to 7 passengers, making it ideal for family trips, group outings, or corporate travel."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, our drivers are highly experienced in long-distance travel, ensuring that you enjoy a smooth and safe journey to your destination."
        },
        {
          question: "What types of vehicles are available for rent besides the Kia Carens?",
          answer: "In addition to the Kia Carens, we offer a variety of vehicles, including sedans, SUVs, mini buses, and premium cars for group or individual travel."
        },
        {
          question: "How do I pay for my Kia Carens rental?",
          answer: "We offer various payment options including cash, credit/debit cards, and online payment via our app, so you can choose the method most convenient for you."
        },
        {
          question: "Can I book a round trip with the Kia Carens?",
          answer: "Yes, you can easily book a round trip for your travel needs. Just provide us with the details of your return journey, and we’ll arrange everything."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any extra charges, like for waiting time or detours, will be communicated to you upfront, ensuring complete transparency in pricing."
        },
        {
          question: "Can I hire a Kia Carens for sightseeing in Pune?",
          answer: "Yes, we offer Kia Carens rentals for sightseeing in Pune. Explore the city’s key attractions with a comfortable and spacious vehicle."
        },
        {
          question: "What is the luggage allowance for a Kia Carens?",
          answer: "The Kia Carens provides ample boot space for luggage. If you have more luggage or specific needs, kindly inform us during the booking, and we’ll make arrangements accordingly."
        },
        {
          question: "Is Morya Cab available for corporate travel with the Kia Carens?",
          answer: "Yes, we provide corporate travel services, offering a reliable and comfortable experience for business-related trips or team outings with the Kia Carens."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Sanjay Patil',
          role: 'Traveler',
          review: "We rented a Kia Carens for a family trip to Mahabaleshwar. The car was spacious, comfortable, and had plenty of space for our luggage. The driver was polite and professional. It was a great experience!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Ms. Neha Gupta',
          role: 'Traveler',
          review: "Morya Cab made our corporate outing so much easier. The Kia Carens was perfect for our group, and the driver was courteous and punctual. The entire process was seamless, and we’ll definitely use their services again!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
      







    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "CarRental",
        "name": "Kia Carens on Rent in Pune",
        "description": "Rent a Kia Carens in Pune for local and outstation trips. Affordable luxury rental service for family vacations, corporate bookings, and airport transfers.",
        "provider": {
          "@type": "Organization",
          "name": "Pune Kia Carens Rentals",
          "url": "https://www.punekiaonrent.com",
          "telephone": "+91-8888888888",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Shop No. 101, Pune Central, Pune",
            "addressLocality": "Pune",
            "addressRegion": "Maharashtra",
            "postalCode": "411001",
            "addressCountry": "IN"
          }
        },
        "offers": {
          "@type": "Offer",
          "priceCurrency": "INR",
          "price": 2500,
          "eligibleRegion": {
            "@type": "Place",
            "name": "Pune"
          },
          "priceValidUntil": "2025-12-31",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "priceCurrency": "INR",
            "price": "2500",
            "unitCode": "DAY",
            "description": "Rent for Kia Carens per day in Pune"
          }
        },
        "keywords": "Kia Carens on Rent Pune, Kia Carens for Rent in Pune, Kia Carens Hire for Outstation, Pune to Shirdi Kia Carens on Rent, Pune to Goa Kia Carens on Rent, Pune to Mumbai Kia Carens on Rent, 7 Seater Car on Rent in Pune, Luxury Carens on Rent for Corporate, Kia Carens Cabs on Rent in Pune, Kia Carens on Rent for Jyotirlinga Darshan, Luxury Car Monthly Rental"
      };
      


    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Kia Carens on Rent in Pune | Affordable Luxury Car Hire for Local & Outstation Trips | Call: +91 9371304510</title>
  <meta
    name="description"
    content="Rent a Kia Carens in Pune for local and outstation trips. Affordable luxury rental service for family vacations, corporate bookings, and airport transfers."
  />
  <meta
    name="keywords"
    content="Kia Carens on Rent Pune, Kia Carens for Rent in Pune, Kia Carens Hire for Outstation, Pune to Shirdi Kia Carens on Rent, Pune to Goa Kia Carens on Rent, Pune to Mumbai Kia Carens on Rent, 7 Seater Car on Rent in Pune, Luxury Carens on Rent for Corporate, Kia Carens Cabs on Rent in Pune"
  />
  <meta property="og:title" content="Kia Carens on Rent in Pune | Affordable Luxury Car Hire for Local & Outstation Trips" />
  <meta
    property="og:description"
    content="Rent a Kia Carens in Pune for local and outstation trips. Affordable luxury rental service for family vacations, corporate bookings, and airport transfers."
  />
  <meta property="og:url" content="https://www.punekiaonrent.com" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://www.punekiaonrent.com/images/kia-carens-rent.jpg" />
  <script type="application/ld+json">
    {JSON.stringify(jsonLD)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/77.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default KIacarenceonrentinpune;